import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const BlogCategories = ({ blogCategories }) => {
  const { t } = useTranslation(['blog']);
  const { assignedLibrary } = useAssignedLibrary();

  return (
    <div className="blog-aside-categories mb-3">
      <h2 className="section-col mt-3">{t('asideCategory')}</h2>
      {blogCategories?.map((cat) => {
        return (
          <Link to={`/${assignedLibrary}/blog/${cat.id}/${cat.slug}/`} className="media d-flex flex-row align-items-center" key={cat.id}>
            {cat?.image && (
              <img className="media-img" src={cat.image} alt={`Category ${cat.name} pic`} />
            )}
            <p className="media-text">{cat.name}</p>
          </Link>
        );
      })}
    </div>
  );
}

export default BlogCategories;
